import { render, staticRenderFns } from "./editorShapePopover.vue?vue&type=template&id=1c98bc36&"
import script from "./editorShapePopover.vue?vue&type=script&lang=js&"
export * from "./editorShapePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports